import React from 'react';
import { Outlet, Link } from "react-router-dom";
import Image from '../Image/Image'
import { 
    Header as Ui_Header, 
    Button, Avatar, Logo, SearchIcon, 
    MoreHorizontalIcon, HelpIcon, 
    BellIcon, LinkIcon, UnlinkIcon
} from '@forge/common';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './Header.css';

interface HeaderProps {
    title?: string;
}

const Header: React.FC<HeaderProps> = ({ title }) => {

    const baseUrl = process.env.REACT_APP_BASE_URL;

      

    return (
        <div>
            <Ui_Header 
                logo={<Image src={baseUrl+"img/logo_blanco.png"} width="130px" />} 
                rightSlot={
                    <div className="grid auto-cols-auto grid-flow-col items-start gap-2">
                        <Image src={baseUrl+"img/logo_honeywell.png"} width="180px" />
                    </div>
                }
                centerSlot={
                    <h3 className="text-xl font-bold text-center text-white-800 hidden md:block">HSE - Proyecto Instrumentación DET</h3>
                }
            />
            <Outlet />
        </div>
        
     
    );
};

export default Header;
